var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", {
      staticClass: "ban",
      staticStyle: {
        "background-image":
          "url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg')",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "g-top" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "ul",
            _vm._l(_vm.classIfyList, function (item) {
              return _c(
                "li",
                {
                  key: item.chipId,
                  class: { on: _vm.activeTab === item.chipId },
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.setActiveTab(item.chipId)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.chipNameCn) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wp is-pc" },
      [
        _c(
          "el-row",
          { staticStyle: { padding: "35px 0" }, attrs: { gutter: 5 } },
          [
            _c(
              "el-col",
              { attrs: { span: 5 } },
              [
                _c(
                  "el-menu",
                  {
                    staticClass: "el-menu-vertical-demo",
                    attrs: {
                      "default-active": _vm.defaultActive,
                      "background-color": "#F7F7F7",
                      "text-color": "#343232",
                      "active-text-color": "#007DC7",
                      "unique-opened": true,
                    },
                    on: { select: _vm.handleSelect },
                  },
                  _vm._l(_vm.leftClassIfyList, function (item) {
                    return _c(
                      "div",
                      { key: item.chipId },
                      [
                        item.children && item.children.length > 0
                          ? _c(
                              "el-submenu",
                              { attrs: { index: item.chipId.toString() } },
                              [
                                _c("template", { slot: "title" }, [
                                  _c("span", [_vm._v(_vm._s(item.chipNameCn))]),
                                ]),
                                _vm._v(" "),
                                _vm._l(item.children, function (child) {
                                  return _c(
                                    "div",
                                    { key: child.chipId },
                                    [
                                      child.children &&
                                      child.children.length > 0
                                        ? _c(
                                            "el-submenu",
                                            {
                                              attrs: {
                                                index: child.chipId.toString(),
                                              },
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "title" },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(child.chipNameCn)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(
                                                child.children,
                                                function (subChild) {
                                                  return _c(
                                                    "el-menu-item",
                                                    {
                                                      key: subChild.chipId,
                                                      attrs: {
                                                        index:
                                                          subChild.chipId.toString(),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            subChild.chipNameCn
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _c(
                                            "el-menu-item",
                                            {
                                              attrs: {
                                                index: child.chipId.toString(),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(child.chipNameCn)
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            )
                          : _c(
                              "el-menu-item",
                              { attrs: { index: item.chipId.toString() } },
                              [_c("span", [_vm._v(_vm._s(item.chipNameCn))])]
                            ),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 19 } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowTable,
                      expression: "isShowTable",
                    },
                  ],
                },
                [
                  _vm.hasSearchField
                    ? _c(
                        "div",
                        { staticClass: "search-container" },
                        [
                          _c(
                            "el-form",
                            {
                              staticClass: "search-form",
                              attrs: { inline: true },
                            },
                            [
                              _vm._l(_vm.searchFields, function (field) {
                                return _c(
                                  "el-form-item",
                                  {
                                    key: field.chipId,
                                    attrs: { label: field.chipNameCn },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        placeholder: `请输入${field.chipNameCn}`,
                                        clearable: "",
                                      },
                                      model: {
                                        value:
                                          _vm.searchFilters[field.randomKey],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchFilters,
                                            field.randomKey,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "searchFilters[field.randomKey]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.filterTableData },
                                    },
                                    [_vm._v("搜索")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.resetFilters } },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.htmlText
                    ? _c("div", { staticClass: "html-content-container" }, [
                        _c("div", { staticClass: "html-content-wrapper" }, [
                          _c("div", {
                            staticClass: "html-content",
                            domProps: {
                              innerHTML: _vm._s(_vm.htmlText.textContent),
                            },
                          }),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "product-table" }, [
                    _c(
                      "div",
                      { staticClass: "table-header" },
                      _vm._l(_vm.dataByJson, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.chipId,
                            staticClass: "table-cell header-cell",
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.chipNameCn) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "table-body" },
                      _vm._l(_vm.filteredInfoList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.chipId,
                            staticClass: "table-row",
                            class: {
                              "table-row-even": index % 2 === 0,
                              "table-row-odd": index % 2 === 1,
                            },
                          },
                          _vm._l(_vm.dataByJson, function (headerItem, indexx) {
                            return _c(
                              "div",
                              {
                                key: headerItem.chipId,
                                staticClass: "table-cell body-cell",
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "center",
                                  "flex-direction": "column",
                                },
                              },
                              [
                                _c("div", [
                                  headerItem.randomKey == "fileUrl"
                                    ? _c("div", [
                                        item.fileUrl == "true"
                                          ? _c("img", {
                                              staticStyle: {
                                                width: "20px",
                                                height: "20px",
                                                cursor: "pointer",
                                              },
                                              attrs: {
                                                src: "/images/product/pdf.svg",
                                                alt: "下载",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.downloadFile(
                                                    item.chipId
                                                  )
                                                },
                                              },
                                            })
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "font-size": "12px",
                                                  color: "#d3d3d3",
                                                },
                                              },
                                              [_vm._v("暂无手册")]
                                            ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNestedValue(
                                              item.chipDetail,
                                              headerItem.randomKey
                                            ) || "-"
                                          )
                                        ),
                                      ]),
                                ]),
                                _vm._v(" "),
                                indexx === 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          background: "#007DC7",
                                          padding: "2px 12px",
                                          "border-radius": "4px",
                                          color: "white",
                                          "margin-top": "5px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleConsult(item)
                                          },
                                        },
                                      },
                                      [_vm._v("\n                    咨询")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isShowTable,
                      expression: "!isShowTable",
                    },
                  ],
                },
                [
                  _vm.selectInfo.fileUrl == "true"
                    ? _c(
                        "div",
                        {
                          staticClass: "click-to-open",
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(
                                _vm.selectInfo.chipId || ""
                              )
                            },
                          },
                        },
                        [_vm._v("点击打开产品规格书")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "chip-container" }, [
                    _c("div", { staticClass: "chip-name" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectInfo.chipDetail
                              ? _vm.selectInfo.chipDetail[
                                  _vm.dataByJson[0].randomKey
                                ]
                              : "-"
                          ) +
                          "\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chip-description" },
                      [
                        _c("img", {
                          attrs: { src: "/images/product/pdf.svg", alt: "" },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.dataByJson, function (item) {
                          return item.chipNameCn != "附件"
                            ? _c("div", { key: item.randomKey }, [
                                _vm._v(
                                  _vm._s(item.chipNameCn) +
                                    " :\n                " +
                                    _vm._s(
                                      _vm.selectInfo.chipDetail
                                        ? _vm.selectInfo.chipDetail[
                                            item.randomKey
                                          ]
                                        : "-"
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e()
                        }),
                      ],
                      2
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chip-submit" }, [
                    _c("div", { staticClass: "chip-submit-title" }, [
                      _vm._v("特殊需求请填写联系信息"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chip-submit-tip" }, [
                      _vm._v(
                        "填写您的电话和电子邮件信息将有助于我们及时与您取得联系，并尽快解决您的问题"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "chip-submit-form" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "ruleForm",
                            staticClass: "demo-ruleForm",
                            attrs: {
                              model: _vm.applyInfo,
                              rules: _vm.rules,
                              "label-width": "80px",
                            },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "联系人", prop: "contacts" } },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.applyInfo.contacts,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.applyInfo, "contacts", $$v)
                                    },
                                    expression: "applyInfo.contacts",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "手机号", prop: "phoneNumber" },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.applyInfo.phoneNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.applyInfo,
                                        "phoneNumber",
                                        $$v
                                      )
                                    },
                                    expression: "applyInfo.phoneNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "公司名称",
                                  prop: "companyName",
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: _vm.applyInfo.companyName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.applyInfo,
                                        "companyName",
                                        $$v
                                      )
                                    },
                                    expression: "applyInfo.companyName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "需求", prop: "demand" } },
                              [
                                _c("el-input", {
                                  attrs: { type: "textarea", rows: 6 },
                                  model: {
                                    value: _vm.applyInfo.demand,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.applyInfo, "demand", $$v)
                                    },
                                    expression: "applyInfo.demand",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      width: "400px",
                                      background: "#007DC7",
                                    },
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.submitForm("ruleForm")
                                      },
                                    },
                                  },
                                  [_vm._v("提交")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "wp is-mobile" }, [
      _vm.type === "mobile" || _vm.type === ""
        ? _c(
            "div",
            { staticClass: "mobile-menu" },
            _vm._l(_vm.menuListByMobile, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "mobile-menu-item",
                  on: {
                    click: function ($event) {
                      return _vm.handleSelectByMobile(item)
                    },
                  },
                },
                [_vm._v(_vm._s(item.chipNameCn))]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "mobile_show_table"
        ? _c("div", { staticClass: "product-table" }, [
            _vm.type === "mobile_show_table"
              ? _c(
                  "div",
                  { staticClass: "table-header" },
                  _vm._l(_vm.dataByJson, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.chipId,
                        staticClass: "table-cell header-cell",
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(item.chipNameCn) +
                            "\n              "
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-body" },
              _vm._l(_vm.filteredInfoList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.chipId,
                    staticClass: "table-row",
                    class: {
                      "table-row-even": index % 2 === 0,
                      "table-row-odd": index % 2 === 1,
                    },
                  },
                  _vm._l(_vm.dataByJson, function (headerItem, indexx) {
                    return _c(
                      "div",
                      {
                        key: headerItem.chipId,
                        staticClass: "table-cell body-cell",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                          "flex-direction": "column",
                        },
                      },
                      [
                        _c("div", [
                          headerItem.randomKey == "fileUrl"
                            ? _c("div", [
                                item.fileUrl == "true"
                                  ? _c("img", {
                                      staticStyle: {
                                        width: "20px",
                                        height: "20px",
                                        cursor: "pointer",
                                      },
                                      attrs: {
                                        src: "/images/product/pdf.svg",
                                        alt: "下载",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.downloadFile(item.chipId)
                                        },
                                      },
                                    })
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "12px",
                                          color: "#d3d3d3",
                                        },
                                      },
                                      [_vm._v("暂无手册")]
                                    ),
                              ])
                            : _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNestedValue(
                                      item.chipDetail,
                                      headerItem.randomKey
                                    ) || "-"
                                  )
                                ),
                              ]),
                        ]),
                        _vm._v(" "),
                        indexx === 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  cursor: "pointer",
                                  background: "#007DC7",
                                  padding: "2px 12px",
                                  "border-radius": "4px",
                                  color: "white",
                                  "margin-top": "5px",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.handleConsult(item)
                                    _vm.type = "mobile_show_zixun"
                                  },
                                },
                              },
                              [_vm._v("\n                    咨询")]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.type === "mobile_show_zixun",
              expression: "type === 'mobile_show_zixun'",
            },
          ],
        },
        [
          _vm.selectInfo.fileUrl == "true"
            ? _c(
                "div",
                {
                  staticClass: "click-to-open",
                  on: {
                    click: function ($event) {
                      return _vm.downloadFile(_vm.selectInfo.chipId || "")
                    },
                  },
                },
                [_vm._v("点击打开产品规格书")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "chip-container" }, [
            _c("div", { staticClass: "chip-name" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.selectInfo.chipDetail
                      ? _vm.selectInfo.chipDetail[_vm.dataByJson[0].randomKey]
                      : "-"
                  ) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chip-description" },
              _vm._l(_vm.dataByJson, function (item) {
                return item.chipNameCn != "附件"
                  ? _c("div", { key: item.randomKey }, [
                      _vm._v(
                        _vm._s(item.chipNameCn) +
                          " :\n                " +
                          _vm._s(
                            _vm.selectInfo.chipDetail
                              ? _vm.selectInfo.chipDetail[item.randomKey]
                              : "-"
                          ) +
                          "\n              "
                      ),
                    ])
                  : _vm._e()
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "chip-submit" }, [
            _c("div", { staticClass: "chip-submit-title" }, [
              _vm._v("特殊需求请填写联系信息"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "chip-submit-tip" }, [
              _vm._v(
                "填写您的电话和电子邮件信息将有助于我们及时与您取得联系，并尽快解决您的问题"
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "chip-submit-form" },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.applyInfo,
                      rules: _vm.rules,
                      "label-position": "left",
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系人", prop: "contacts" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.applyInfo.contacts,
                            callback: function ($$v) {
                              _vm.$set(_vm.applyInfo, "contacts", $$v)
                            },
                            expression: "applyInfo.contacts",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "手机号", prop: "phoneNumber" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.applyInfo.phoneNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.applyInfo, "phoneNumber", $$v)
                            },
                            expression: "applyInfo.phoneNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "公司名称", prop: "companyName" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.applyInfo.companyName,
                            callback: function ($$v) {
                              _vm.$set(_vm.applyInfo, "companyName", $$v)
                            },
                            expression: "applyInfo.companyName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "需求", prop: "demand" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 6 },
                          model: {
                            value: _vm.applyInfo.demand,
                            callback: function ($$v) {
                              _vm.$set(_vm.applyInfo, "demand", $$v)
                            },
                            expression: "applyInfo.demand",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "100%",
                              background: "#007DC7",
                            },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("提交")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cur" }, [
      _vm._v("\n        当前位置：\n        "),
      _c("a", { attrs: { href: "/" } }, [_vm._v("首页")]),
      _vm._v(">\n        "),
      _c("a", { attrs: { href: "/product-center" } }, [_vm._v("产品中心")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }